module.exports = __webpack_public_path__ + "media/mypage/images/banner-a0c92bb8bab45567ee580bd376cc12f8.png";